import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CurrencyPrime = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9.5" stroke="currentColor" />
    <path
      d="M12.827 4C13.4558 4 13.9918 4.16973 14.4349 4.50931C14.8637 4.84899 15.2495 5.25549 15.5926 5.72806C15.8642 6.11206 16 6.59944 16 7.1902V9.16166C16 9.70812 15.8642 10.1886 15.5926 10.6022C15.5067 10.7498 15.3283 10.9567 15.0569 11.2224C14.7996 11.4882 14.5921 11.6802 14.4349 11.7984C13.9775 12.138 13.4415 12.3077 12.827 12.3077H9.25354V17H6.57345V12.3077H3V9.53846H6.57345V4H12.827ZM9.25354 9.53846H12.827C12.8699 9.53846 12.9557 9.47903 13.0844 9.36088C13.2272 9.22803 13.3273 9.10994 13.3845 9.00661V7.30108C13.2415 7.06477 13.0557 6.88738 12.827 6.76923H9.25354V9.53846Z"
      fill="currentColor"
    />
  </svg>,
  'CurrencyPrime'
);
